import {
  createDirectus,
  rest,
  //staticToken,
  // withOptions,
  //refresh,
  readItems,
  authentication,
  // graphql,
  // withToken,
  createItem,
} from "@directus/sdk";

const client = createDirectus(location.origin) //"https://ds.crm.iotd.ru"
  .with(authentication("cookie"))
  .with(rest());
//.with(authentication("cookie", { credentials: "include" }))
//.with(graphql({ credentials: "include" }))
//.with(rest({ credentials: "include" }))
//   .with(
//     rest({
//       onRequest: (options) => ({ ...options, cache: "no-store" }),
//       credentials: "include",
//     })
//   );

async function get() {
  // const token = await client.getToken();
  // console.log("token", token);
  return await client.request(readItems("groups"));
}

async function create(data) {
  return await client.request(createItem("groups", data));
}

export default {
  get,
  create,
};
